<template>
  <div class="vs-checkbox" v-if="options.length > 0">
    <span class="-label">{{ label }}</span>
    <div class="-input">
      <template v-for="(option, index) in options">
        <div class="--each" :key="index">
          <label :for="option.value">{{ option.title }}</label>
          <input
            type="checkbox"
            :id="option.value"
            :value="option.value"
            v-model="selection"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      label: String,
      prop: String,
      options: Array,
      edata: {
        type: String,
        default: null
      }
    },
    data: () => ({
      selection: ""
    }),
    watch: {
      selection: function (val) {
        if (this.prop && val) {
          this.$emit("input", this.prop, val);
        }
      }
    },
    beforeUpdate() {
      if (this.edata !== null) {
        this.$set(this, 'selection', this.edata);
      }
    }
  }
</script>

<style lang="scss" scoped>


</style>
